import { memo, useEffect } from "react";
import Navbar from ".././Navbar";
import Footer from ".././Footer";
import { Link } from "react-router-dom";
import { sendViewEvent } from "../../services/AppscasaAnalytics";
import { Helmet } from "react-helmet";
import { products } from "./productsData";
import { openBusinessWhatsApp } from "../../helper/HelperUtils";

const detailTextStyle = { fontSize: "14px", fontWeight: 700 };

const ProductCard = memo(({ product }) => {
  const productDetails = [
    { label: "Software Version:", value: product.softwareVersion },
    { label: "Compatibility:", value: product.compatibility },
    { label: "Last Updated:", value: product.updatedAt },
  ];

  const handleRequestToBuy = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const requestDate = new Date().toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    const productLink = `${window.location.origin}/product-details/${product.slug}`;

    openBusinessWhatsApp(
      `Hello Appscasa Team,\n\nI would like to enquire about the following product:\n\n- *Request Type:* Request To Buy\n- *Product:* ${product.title}\n- *Request Date:* ${requestDate}\n- *Price:* ${product.price}\n- *Product Link:* ${productLink}\n\nKindly share the next steps and related details.`
    );
  };

  return (
    <div className="col-md-6 mb-4 d-flex">
      <Link
        to={`/product-details/${product.slug}`}
        className="product-item p-3 bg-white rounded shadow-sm w-100 d-flex flex-column justify-content-between text-decoration-none"
      >
        <div className="row g-4">
          <div className="item active col-md-6 d-flex flex-column h-100">
            <h6 className="mb-2">{product.title}</h6>
            <p className="mb-2">{product.description}</p>

            <div className="mb-2 text-muted">
              {productDetails.map(({ label, value }) => (
                <div
                  key={label}
                  className="d-flex align-items-center gap-1 mb-2"
                  style={detailTextStyle}
                >
                  <span className="text-black">{label}</span>
                  <span className="text-black ml-1">{value}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="col-md-6 d-flex align-items-center justify-content-center">
            <img
              src={product.image}
              alt={product.title}
              className="img-fluid rounded"
            />
          </div>
        </div>
        <div className="mt-auto d-flex justify-content-between gap-3">
          <h6 className="fw-bold text-black">{product.price}</h6>
          <button
            type="button"
            className="butn butn-bg"
            onClick={handleRequestToBuy}
          >
            <span>{product.buttonText}</span>
          </button>
        </div>
      </Link>
    </div>
  );
});

const Products = () => {
  useEffect(() => {
    sendViewEvent(window.location.pathname);
  }, []);

  return (
    <>
      <Helmet>
        <title>Hybrid And Native App Development Price</title>
        <meta
          name="description"
          content="Appscasa has Highly Skilled Developer and We provide Less Rate as compared to market."
        />
      </Helmet>
      <Navbar />

      <header
        className="pages valign bg-img parallaxie"
        data-background="assets/img/bg.jpg"
        data-overlay-dark={7}
      >
        <div className="container">
          <div className="row">
            <div className="full-width mt-80">
              <h5>Products</h5>
              <h6>
                <Link to="/">Home</Link>/
                <Link to="/products" className="active">
                  Products
                </Link>
              </h6>
            </div>
          </div>
        </div>
      </header>

      <section
        className="products-section section-padding bg-gray"
        data-scroll-index={3}
      >
        <div className="container">
          <div className="row g-4">
            {products.map((product) => (
              <ProductCard key={product.title} product={product} />
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Products;
